// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleGroupSmall_container__gub5e","title":"ArticleGroupSmall_title__YiUmb","grid":"ArticleGroupSmall_grid__uJ_Qw"};